'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

exports.default = loadGPTScript;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Async loader of gpt tag on client
 * @param {function} resolve callback function
 * @param {function} reject callback function
 */
var doloadGPTScript = function doloadGPTScript(resolve, reject) {
  window.googletag = window.googletag || {};
  window.googletag.cmd = window.googletag.cmd || [];

  var scriptTag = document.createElement('script');
  scriptTag.src = document.location.protocol + '//www.googletagservices.com/tag/js/gpt.js';
  scriptTag.async = true;
  scriptTag.type = 'text/javascript';
  scriptTag.onerror = function scriptTagOnError(errs) {
    reject(errs);
  };
  scriptTag.onload = function scriptTagOnLoad() {
    resolve(window.googletag);
  };
  document.getElementsByTagName('head')[0].appendChild(scriptTag);
};

/**
 * Async loader of gpt tag on client
 * @constructor
 */
function loadGPTScript() {
  return new _promise2.default(function (resolve, reject) {
    doloadGPTScript(resolve, reject);
  });
}


//////////////////
// WEBPACK FOOTER
// ./~/@univision/fe-commons/dist/utils/ads/vendors/dfpLoader.js
// module id = 124
// module chunks = 35783957827783 71851226274881